import * as React from "react"
import type { SVGProps } from "react"
const SvgHeart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 21.04q-.35 0-.71-.13a2 2 0 0 1-.64-.4l-1.72-1.57a68 68 0 0 1-4.8-4.81A7.7 7.7 0 0 1 2 8.86q0-2.34 1.58-3.92A5.3 5.3 0 0 1 7.5 3.36q1.33 0 2.5.57 1.17.55 2 1.53a6 6 0 0 1 2-1.53 6 6 0 0 1 2.5-.57q2.36 0 3.93 1.58A5.3 5.3 0 0 1 22 8.86q0 2.88-2.12 5.28a60 60 0 0 1-4.83 4.82l-1.7 1.55a2 2 0 0 1-.64.4q-.36.13-.71.13m-.95-13.58Q10.33 6.44 9.5 5.9a3.6 3.6 0 0 0-2-.54A3.4 3.4 0 0 0 4 8.86q0 1.31.93 2.77.92 1.46 2.2 2.83a38 38 0 0 0 2.66 2.58L12 19l2.21-1.97q1.37-1.2 2.65-2.58a19 19 0 0 0 2.22-2.83q.92-1.47.92-2.77a3.4 3.4 0 0 0-3.5-3.5q-1.17 0-2 .54t-1.55 1.56a1.1 1.1 0 0 1-.95.5 1.1 1.1 0 0 1-.95-.5" />
  </svg>
)
export default SvgHeart
